/**
 * simulator/store.js
 * Puente módulo↔React para el axiosClient del simulador.
 * Permite que el axiosClient (módulo ES) acceda al estado y dispatch
 * del SimulatorContext (React).
 */

let _getState = () => ({});
let _dispatch = () => {};

export const linkStore = (getState, dispatch) => {
  _getState = getState;
  _dispatch = dispatch;
};

export const getState = () => _getState();
export const dispatch = (action) => _dispatch(action);
